import { render } from "./CompletedTrainingView.vue?vue&type=template&id=06770314"
import script from "./CompletedTrainingView.vue?vue&type=script&lang=js"
export * from "./CompletedTrainingView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__